import { Settings as ProSettings } from '@ant-design/pro-layout';

type DefaultSettings = ProSettings & {
  pwa: boolean;
};

const proSettings: DefaultSettings = {
  navTheme: 'dark',
  // 拂晓蓝
  primaryColor:  '#5487DF',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: false,
  siderWidth: 220,
  fixSiderbar: true,
  colorWeak: false,
  menu: {
    locale: false,
    // @ts-ignore
    disableLocal:true,
  },
  title: '中枢业务平台',
  pwa: false,
  iconfontUrl: '',
};

export type { DefaultSettings };

export default proSettings;
